<template>
  <div class="card">
    <h3
      class="p-6"
      v-if="rol !== 'supervisor' && rol !== 'consultas departamentales'"
    >
      {{
        nombre_recinto_penitenciario === "TODOS" ? "" : "CENTRO PENITENCIARIO: "
      }}
      {{
        nombre_recinto_penitenciario === "TODOS"
          ? "TODOS LOS RECINTOS"
          : nombre_recinto_penitenciario
      }}
      -
      {{
        departamento_centro_penitenciario === "NACIONAL"
          ? "NIVEL NACIONAL"
          : departamento_centro_penitenciario
      }}
    </h3>
    <h3
      class="p-10"
      v-else-if="rol === 'supervisor' || rol === 'consultas departamentales'"
    >
      SUPERVISIÓN: {{ departamento_supervisar }}
    </h3>
    <div class="card-header border-0 pt-6">
      <!-- botones -->
      <div class="card-toolbar">
        <div
          class="d-flex justify-content-end"
          data-kt-customer-table-toolbar="base"
        >
          <!--botón agregar nueva ppl-->
          <!-- <button
            type="button"
            class="btn btn-primary px-3"
            style="margin-right: 10px"
            @click="NewRegister"
          >
            <i
              title="Nuevo registro"
              style="font-size: 1em; color: white"
              class="fas fa-plus"
            ></i>
            Nueva filiación manual
          </button> -->
          <!-- boton graficar -->
          <div class="btn-group dropend">
            <button
              type="button"
              class="btn btn-success dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              :disabled="
                disabledButtonGraf === 0 || disabledButtonGrafGroup === false
              "
            >
              Graficar
            </button>
            <ul class="dropdown-menu">
              <li>
                <a
                  class="dropdown-item"
                  type="button"
                  @click="getSelectedData(1)"
                  >Barras</a
                >
              </li>
              <li>
                <a
                  class="dropdown-item"
                  type="button"
                  @click="getSelectedData(2)"
                  >Torta</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- tabla de datos -->
    <div class="card-body pt-0">
      <DxDataGrid
        id="gridContainer"
        ref="dataGridRef"
        :data-source="listaPreventivos"
        key-expr="id_persona"
        :allow-column-reordering="false"
        :row-alternation-enabled="false"
        :show-borders="true"
        @exporting="onExporting"
        @row-prepared="onRowPrepared"
        @selection-changed="onSelectionChanged"
        @content-ready="onContentReady"
      >
        <DxFilterRow :visible="true" />
        <DxPager
          :visible="true"
          :allowed-page-sizes="pageSizes"
          :show-page-size-selector="true"
        />
        <DxPaging :page-size="10" />
        <DxGroupPanel :visible="true" />
        <DxGrouping :auto-expand-all="false" />
        <DxExport :enabled="true" :allow-export-selected-data="true" />
        <DxSelection mode="multiple" show-check-boxes-mode="always" />
        <DxColumn
          :width="100"
          :allow-sorting="false"
          caption="Acciones"
          cell-template="cellTemplate"
        />
        <template #cellTemplate="{ data }">
          <!-- <buttonAddOrder :id_persona="data.data.id_persona"></buttonAddOrder> -->
          <button
            type="button"
            class="btn px-3"
            @click="printKardex(data.data.id_persona)"
          >
            <i
              title="Reimprimir kardex"
              style="font-size: 1.5em; color: black"
              class="fas fa-print"
            ></i>
          </button>
          <!-- <span
            v-if="alertaPreventivos(data.data)"
            class="badge badge-pill badge-warning transicion_preventivos"
            :title="`Desde el día ${DateFormat(
              new Date(data.data.fecha_ingreso_recinto)
            )}, ya pasaron 6 meses de detención preventiva.`"
            >ATENCIÓN</span
          > -->
        </template>
        <DxColumn
          :width="170"
          data-field="codigo_file_ppl"
          :allow-grouping="false"
          caption="Código file PPL"
        />
        <DxColumn :width="170" data-field="nombres" :allow-grouping="false" />
        <DxColumn
          :width="170"
          data-field="primer_apellido"
          :allow-grouping="false"
        />
        <DxColumn
          :width="170"
          data-field="segundo_apellido"
          :allow-grouping="false"
        />
        <DxColumn
          :width="285"
          data-field="nombre_tipo_documento_identidad"
          caption="Tipo documento de identidad"
        />
        <DxColumn
          :width="200"
          data-field="nro_documento"
          :allow-grouping="false"
          caption="Nro. documento de identidad"
        />
        <DxColumn
          :width="70"
          data-field="complemento"
          caption="Comp."
          :allow-grouping="false"
        />
        <DxColumn
          :width="200"
          data-field="fecha_nacimiento"
          data-type="date"
          :format="DateFormat"
        />
        <DxColumn :width="100" data-field="genero" />
        <DxColumn
          :width="130"
          data-field="nombre_estado_civil"
          caption="Estado civil"
        />
        <DxColumn :width="100" data-field="pais" caption="País" />
        <DxColumn
          :width="130"
          data-field="dep_nacimiento"
          caption="Departamento"
        />
        <DxColumn
          :width="200"
          data-field="nombre_recinto_penitenciario"
          caption="Centro Penitenciario"
        />
        <DxColumn
          :width="235"
          data-field="recinto_departamento"
          caption="Departamento centro penitenciario"
        />
        <DxColumn
          :width="450"
          data-field="descripcion_delito"
          caption="Delito"
        />
        <DxColumn
          :width="130"
          data-field="tipo_mandamiento"
          caption="Situación Jurídica"
        />
        <DxColumn
          :width="190"
          data-field="fecha_ingreso_recinto"
          data-type="date"
          :format="DateFormat"
          caption="Fecha de ingreso al recinto"
        />
        <DxColumn
          :width="300"
          :allow-sorting="false"
          caption="Tiempo Transcurrido"
          cell-template="templateTiempoTranscurrido"
        />
        <template #templateTiempoTranscurrido="{ data }">
          <span style="text-transform: uppercase">
            {{ calcularTiempoTranscurrido(data.data.fecha_ingreso_recinto) }}
          </span>
        </template>
        <DxColumn
          :width="300"
          data-field="nombre_completo_juez"
          caption="Nombre del juez"
        />
        <DxColumn :width="600" data-field="nombre_juzgado" caption="Juzgado" />
        <DxColumn
          :width="200"
          data-field="nombre_grado_profesion"
          caption="Profesión"
        />
        <DxColumn :width="150" data-field="nombre_oficio" caption="Oficio" />
        <DxColumn
          :width="200"
          data-field="nombre_grado_instruccion"
          caption="Grado de instrucción"
        />
        <DxColumn
          :width="150"
          data-field="nombre_identificacion_etnica"
          caption="Identidad étnica"
        />
        <DxColumn
          :width="150"
          data-field="nombre_orientacion_sexual"
          caption="Identidad sexual"
        />
        <DxColumn
          :width="250"
          data-field="usuario_nombre"
          caption="Nombre filiador"
        />
        <DxGroupPanel :visible="true" />
        <DxSearchPanel :visible="true" :highlight-case-sensitive="true" />
        <DxSummary>
          <DxGroupItem
            column="recinto_departamento"
            summary-type="count"
            display-format="{0} Persona(s) Privada de Libertad"
          />
          <DxTotalItem
            column="id_persona"
            summary-type="count"
            display-format="Total count: {0} Personas privadas de libertad"
          />
        </DxSummary>
        <DxSortByGroupSummaryInfo summary-item="primer_apellido" />
      </DxDataGrid>
    </div>
  </div>
  <!--chart de barras de un grupo seleccionado  -->
  <DxChart
    v-if="chartStatus == 'one' && typeChart == 'barras'"
    id="chart"
    palette="Soft"
    :data-source="chartDataValues"
    title="Sistema de Régimen Penitenciario"
  >
    <DxSeriesTemplate name-field="nombre" />
    <DxCommonSeriesSettings
      :ignore-empty-points="true"
      argument-field="nombre"
      value-field="count"
      type="bar"
    >
      <DxLabel :visible="true" background-color="#c18e92" />
    </DxCommonSeriesSettings>
    <DxArgumentAxis :tick-interval="200" title="">
      <DxLabel :rotation-angle="80" display-mode="rotate" />
    </DxArgumentAxis>
    <DxValueAxis
      value-type="numeric"
      type="discrete"
      :tick-interval="1000"
      title="Número de PPL"
    ></DxValueAxis>
    <DxLegend :visible="false" />
    <DxExport :enabled="true" />
    <DxTooltip
      :enabled="true"
      :customize-tooltip="customizeTooltip1"
      location="edge"
    />
  </DxChart>
  <!-- chart de barras de dos grupos seleccionados -->
  <DxChart
    v-if="chartStatus == 'two' && typeChart == 'barras'"
    id="chart1"
    palette="Soft"
    :data-source="chartDataTwoParams.dataBars"
    title="Sistema de régimen penitenciario"
  >
    <DxSeriesTemplate name-field="data1" />
    <DxCommonSeriesSettings
      :ignore-empty-points="true"
      argument-field="data2"
      value-field="count"
      type="bar"
    >
      <DxLabel :visible="true" background-color="#c18e92" />
    </DxCommonSeriesSettings>
    <DxArgumentAxis :tick-interval="500" title="">
      <DxLabel :rotation-angle="-80" display-mode="rotate" />
    </DxArgumentAxis>
    <DxValueAxis
      value-type="numeric"
      type="discrete"
      :tick-interval="1000"
      title="Número de PPL"
    ></DxValueAxis>
    <DxTooltip
      :enabled="true"
      :customize-tooltip="customizeTooltip"
      location="edge"
    />
    <DxExport :enabled="true" />
    <DxZoomAndPan argument-axis="both" value-axis="both" />
    <DxLegend
      :visible="true"
      vertical-alignment="bottom"
      horizontal-alignment="center"
    />
  </DxChart>
  <!-- chart en torta de un grupo seleccionado  -->
  <DxPieChart
    v-if="chartStatus == 'one' && typeChart == 'torta'"
    id="pie"
    :data-source="chartDataValues"
    palette="Bright"
    title="Sistema de Régimen Penitenciario"
    @point-click="pointClickHandler($event)"
    @legend-click="legendClickHandler($event)"
  >
    <DxSeries argument-field="nombre" value-field="count">
      <DxLabel :visible="true">
        <DxConnector :visible="true" :width="1" />
      </DxLabel>
    </DxSeries>
    <DxTooltip
      :enabled="true"
      :customize-tooltip="customizeTooltipPie"
      location="edge"
    />
    <DxZoomAndPan argument-axis="both" value-axis="both" />
    <DxExport :enabled="true" />
  </DxPieChart>
  <!-- chart en torta de dos grupos seleccionados -->
  <DxPieChart
    v-if="chartStatus == 'two' && typeChart == 'torta'"
    id="pie"
    :data-source="chartDataTwoParams.data1"
    :inner-radius="0.2"
    type="doughnut"
    palette="Ocean"
    @point-click="pointClickHandler($event)"
    @legend-click="legendClickHandler($event)"
  >
    <DxTitle text="Sistema de Régimen Penitenciario"> </DxTitle>
    <DxZoomAndPan argument-axis="both" value-axis="both" />
    <DxLegend :visible="true" />
    <DxExport :enabled="true" />
    <DxCommonSeriesSettings>
      <DxLabel :visible="true">
        <DxConnector :visible="true" :width="1" />
      </DxLabel>
    </DxCommonSeriesSettings>
    <DxTooltip
      :enabled="true"
      location="edge"
      :customize-tooltip="customizeTooltipPie2"
    />
    <template
      v-for="(item, key, index) in chartDataTwoParams.data2"
      :key="index"
    >
      <DxSeries
        :name="item.data2"
        argument-field="nombre"
        :value-field="item.data2"
      />
    </template>
  </DxPieChart>
  <!-- <DxSeries name="data2" argument-field="nombre" value-field="data2" />
    <DxSeries name="data1" argument-field="nombre" value-field="data1" /> -->
  <!-- loader -->
  <loading
    v-model:active="isLoading"
    :can-cancel="false"
    :is-full-page="true"
    loader="bars"
    :height="100"
    :width="100"
  ></loading>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
///import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { defineComponent, ref, onMounted, computed } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import filiation from "@/filiation/composables/useFiliation";
import useAuth from "@/auth/composables/useAuth";
//import buttonAddOrder from "@/views/buttons/buttonAddOrder.vue";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import esMessages from "devextreme/localization/messages/es.json";
import { locale, loadMessages } from "devextreme/localization";
//import { useRouter } from "vue-router";
import formatDate from "@/helpers/formatDate";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { formatDistance, addMonths } from "date-fns";
import { es } from "date-fns/esm/locale";
import {
  DxDataGrid,
  DxFilterRow,
  DxColumn,
  DxExport,
  DxSelection,
  DxGroupPanel,
  DxGrouping,
  DxSearchPanel,
  DxPaging,
  DxPager,
  DxSummary,
  DxGroupItem,
  DxSortByGroupSummaryInfo,
  //DxButton,
  DxTotalItem,
} from "devextreme-vue/data-grid";
import DxChart, {
  DxValueAxis,
  DxArgumentAxis,
  DxLegend,
  DxLabel,
  DxSeriesTemplate,
  DxCommonSeriesSettings,
  DxTooltip,
  DxZoomAndPan,
} from "devextreme-vue/chart";
import DxPieChart, {
  DxSeries,
  DxConnector,
  DxTitle,
} from "devextreme-vue/pie-chart";
import "devextreme/dist/css/dx.light.css";
export default defineComponent({
  name: "private-liberty-list-preventivo",
  components: {
    DxDataGrid,
    DxFilterRow,
    DxColumn,
    DxExport,
    DxSelection,
    DxGroupPanel,
    DxGrouping,
    DxSearchPanel,
    DxPaging,
    DxPager,
    DxSummary,
    DxGroupItem,
    DxSortByGroupSummaryInfo,
    DxTotalItem,

    DxChart,
    DxValueAxis,
    DxArgumentAxis,
    DxLabel,
    DxLegend,
    DxTooltip,
    DxZoomAndPan,
    DxSeriesTemplate,
    DxCommonSeriesSettings,

    DxPieChart,
    DxSeries,
    DxConnector,
    DxTitle,

    Loading,
    //buttonAddOrder,
  },
  setup() {
    loadMessages(esMessages);
    locale(navigator.language);
    const isAdmin = ref(false);
    const file = ref(null);
    const sentencia_cumplida = ref(false);
    const pageSizes = ref([10, 25, 50, 100]);
    let isLoading = ref(false);
    let dataGridRef = ref();
    let selectedRowsData = [];
    let colCount = ref(0);
    let colNames = [];
    let dataValuesFiltered = [];
    let typeChart = ref("");
    // subir archivos inicio
    // const handleFileUpload = async (event, id) => {
    //   file.value = event.target.files[0];
    //   const { data } = await uploadFile([file.value, id]);
    //   if (data.ok == true) {
    //     Swal.fire({
    //       title: "Archivo cargado correctamente",
    //       text: "La resolución fue registrada exitosamente.",
    //       icon: "success",
    //       buttonsStyling: false,
    //       confirmButtonText: "Continuar",
    //       customClass: {
    //         confirmButton: "btn fw-bold btn-light-primary",
    //       },
    //     });
    //     pplList();
    //   } else {
    //     Swal.fire({
    //       title: "Error",
    //       text: "El archivo no pudo ser cargado.",
    //       icon: "error",
    //       buttonsStyling: false,
    //       confirmButtonText: "Continuar",
    //       customClass: {
    //         confirmButton: "btn fw-bold btn-light-primary",
    //       },
    //     });
    //   }
    // };
    // const uploadResolution = () => {
    //   document.getElementById("fileUpload").click();
    // };
    // subir archivos final
    const pointClickHandler = (e) => {
      toggleVisibility(e.target);
    };
    const legendClickHandler = (e) => {
      const arg = e.target;
      const item = e.component.getAllSeries()[0].getPointsByArg(arg)[0];

      toggleVisibility(item);
    };
    const toggleVisibility = (item) => {
      item.isVisible() ? item.hide() : item.show();
    };
    const DateFormat = (date) => {
      const formattedDate = formatDate(date);
      return formattedDate;
    };
    const {
      PrivateLibertyList,
      listPpl,
      kardex,
      // uploadFile,
      // resolution,
      chartData,
      chartDataValues,
      chartDataTwoParams,
      chartStatus,
    } = filiation();
    const {
      rol,
      nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      departamento_supervisar,
      id_recinto,
    } = useAuth();
    //const router = useRouter();
    // const NewRegister = () => {
    //   router.push({ name: "registerForm" });
    // };
    const pplList = async () => {
      isLoading.value = true;
      await PrivateLibertyList({ id_recinto, departamento_supervisar });
      isLoading.value = false;
    };
    const calcularTiempoTranscurrido = (fecha_ingreso) => {
      const fecha_actual = new Date();
      return `Recluido ${formatDistance(new Date(fecha_ingreso), fecha_actual, {
        addSuffix: true,
        locale: es,
      })}`;
    };
    const calcularTiempoRestante = (fecha_salida) => {
      const fecha_actual = new Date();
      if (fecha_salida == null) {
        return;
      } else if (new Date(fecha_salida) >= fecha_actual) {
        return `Cumple ${formatDistance(new Date(fecha_salida), fecha_actual, {
          addSuffix: true,
          locale: es,
        })}`;
      } else if (new Date(fecha_salida) < fecha_actual) {
        return `Cumplió ${formatDistance(new Date(fecha_salida), fecha_actual, {
          addSuffix: true,
          locale: es,
        })}`;
      }
    };
    const alertaPreventivos = (e) => {
      if (
        e.tipo_mandamiento === "PREVENTIVO" &&
        e.fecha_salida_sentencia === null
      ) {
        const fecha_actual = new Date();
        const fecha_ingreso = addMonths(new Date(e.fecha_ingreso_recinto), 6);
        fecha_actual.setHours(0, 0, 0, 0);
        fecha_ingreso.setHours(0, 0, 0, 0);
        if (fecha_ingreso.getTime() <= fecha_actual.getTime()) {
          return true;
        } else {
          return false;
        }
      }
    };
    const onRowPrepared = (e) => {
      if (e.rowType === "data" && e.data.fecha_salida_sentencia !== null) {
        const fecha_actual = new Date();
        const fecha_salida = new Date(e.data.fecha_salida_sentencia);
        fecha_actual.setHours(0, 0, 0, 0);
        fecha_salida.setHours(0, 0, 0, 0);
        if (fecha_salida.getTime() <= fecha_actual.getTime()) {
          sentencia_cumplida.value = true;
        } else {
          sentencia_cumplida.value = false;
        }
      } else if (
        e.rowType === "data" &&
        e.data.fecha_salida_sentencia === null
      ) {
        const fecha_actual = new Date();
        const fecha_ingreso = addMonths(
          new Date(e.data.fecha_ingreso_recinto),
          6
        );
        fecha_actual.setHours(0, 0, 0, 0);
        fecha_ingreso.setHours(0, 0, 0, 0);
      }
    };
    const onExporting = (e) => {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("tableData");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "SirepReport.xlsx"
          );
        });
      });
      e.cancel = true;
    };
    const editData = async (e) => {
      alert(e);
      //await passData({ id_persona: e.id_persona, id_casoppl: e.id_casoppl });
    };
    const printKardex = async (e) => {
      await kardex(e);
    };
    // const viewResolution = async (id) => {
    //   await resolution(id);
    // };
    const customizeTooltip = (pointInfo) => {
      return {
        text: `${pointInfo.argument} <br> ${pointInfo.seriesName} <br> ${pointInfo.valueText} persona(s) privada(s) de libertad`,
      };
    };
    const customizeTooltip1 = (pointInfo) => {
      return {
        text: `${pointInfo.seriesName} <br> ${pointInfo.valueText} persona(s) privada(s) de libertad`,
      };
    };
    const customizeTooltipPie = (pointInfo) => {
      return {
        text: `${pointInfo.argument} <br> ${pointInfo.valueText} persona(s) privada(s) de libertad (${pointInfo.percentText})`,
      };
    };
    const customizeTooltipPie2 = (pointInfo) => {
      return {
        text: `${pointInfo.seriesName}<br>${pointInfo.argumentText}<br>${pointInfo.valueText} persona(s) privadas de libertad (${pointInfo.percentText})`,
      };
    };
    const getSelectedData = async (value) => {
      if (value == 1) {
        typeChart.value = "barras";
      } else if (value == 2) {
        typeChart.value = "torta";
      }
      isLoading.value = true;
      selectedRowsData.push(dataGrid.value.getSelectedRowsData());
      for (let i = 0; i < dataGrid.value.columnCount(); i++) {
        if (dataGrid.value.columnOption(i, "groupIndex") > -1) {
          colCount.value++;
          colNames.push(dataGrid.value.columnOption(i, "dataField"));
        }
      }
      const { data } = await chartData({
        col: colNames,
        data: selectedRowsData,
      });
      data ? (isLoading.value = false) : (isLoading.value = true);
      if (data) {
        Swal.fire({
          title: "Generado",
          text: "El gráfico fue generado con éxito.",
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
      } else {
        isLoading.value = false;
        Swal.fire({
          title: "El gráfico no pudo ser generado",
          text: "Solo debe seleccionar hasta dos agrupaciones.",
          icon: "info",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
      }
      selectedRowsData = [];
      colCount = ref(0);
      colNames = [];
      dataValuesFiltered = [];
      dataGrid.value.clearFilter();
      dataGrid.value.clearGrouping();
      dataGrid.value.clearSelection();
    };
    let disabledButtonGraf = ref(0);
    let disabledButtonGrafGroup = ref(false);
    const onSelectionChanged = ({ selectedRowKeys }) => {
      disabledButtonGraf.value = selectedRowKeys.length;
    };
    const onContentReady = async (e) => {
      var isGrouped = !!e.component.columnOption("groupIndex:0");
      isGrouped
        ? (disabledButtonGrafGroup.value = true)
        : (disabledButtonGrafGroup.value = false);
    };
    const dataGrid = computed(() => {
      return dataGridRef.value.instance;
    });
    const listaPreventivos = computed(() => {
      if (listPpl.value != null) {
        const result = listPpl.value.filter(
          (mandamiento) => mandamiento.tipo_mandamiento == "PREVENTIVO"
        );
        return result;
      } else {
        return 0;
      }
    });
    onMounted(() => {
      setCurrentPageBreadcrumbs("Lista privados de libertad preventivos", [
        "Listas",
      ]);
      pplList();
      const userLogged = localStorage.getItem("roles").split(",");
      for (let rol of userLogged) {
        if (rol.toUpperCase() === "ADMIN") {
          isAdmin.value = true;
        }
      }
    });
    return {
      isAdmin,
      file,
      isLoading,
      dataGridRef,
      dataGrid,
      listaPreventivos,
      selectedRowsData,
      colCount,
      colNames,
      dataValuesFiltered,
      listPpl,
      pageSizes,
      sentencia_cumplida,
      typeChart,
      chartDataValues,
      chartDataTwoParams,
      chartStatus,
      disabledButtonGraf,
      disabledButtonGrafGroup,

      rol,
      nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      departamento_supervisar,
      id_recinto,
      
      onSelectionChanged,
      onContentReady,
      //uploadResolution,
      //handleFileUpload,
      //viewResolution,
      alertaPreventivos,
      pointClickHandler,
      legendClickHandler,
      toggleVisibility,
      calcularTiempoTranscurrido,
      calcularTiempoRestante,
      onRowPrepared,
      //NewRegister,
      printKardex,
      pplList,
      editData,
      DateFormat,
      onExporting,
      getSelectedData,
      customizeTooltip,
      customizeTooltip1,
      customizeTooltipPie,
      customizeTooltipPie2,
    };
  },
});
</script>
<style>
.transicion {
  animation: parpadeo 2s infinite;
}
@keyframes parpadeo {
  0% {
    background-color: rgb(209, 205, 205);
    color: black;
  }
  50% {
    background-color: red;
    color: aliceblue;
  }
  100% {
    background-color: rgb(209, 205, 205);
    color: black;
  }
}
.transicion_preventivos {
  animation: parpadeo_preventivos 2s infinite;
}
@keyframes parpadeo_preventivos {
  0% {
    background-color: rgb(226, 226, 189);
    color: grey;
  }
  50% {
    background-color: yellow;
    color: black;
  }
  100% {
    background-color: rgb(226, 226, 189);
    color: grey;
  }
}
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}
.tooltip .tiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 3px;
  padding: 6px 0;
  position: absolute;
  z-index: 1;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
}
.tooltip .tiptext::after {
  content: "";
  position: absolute;
  border-width: 5px;
  border-style: solid;
}
.tooltip:hover .tiptext {
  visibility: visible;
}
#chart {
  height: 1000px;
  width: 100%;
}
#chart1 {
  height: 1000px;
  width: 100%;
}
#pie {
  height: 700px;
  width: 100%;
}
</style>
